import UserDetailPage from "./UserDetailPage";
import AdminUsersPage from "./AdminUsersPage";

export default class AdminUsersDetailPage extends UserDetailPage {
  static PageInfo = {  
    parent: AdminUsersPage,
    hidden:true,
    path: "/Admin/Users/Detail/:target",
    name: "menu.user",
    permission: { "CONFIGURATION_USERS_ACCESSING": true  },
    access: { 1: true },
    icon: "user"
  }
}  